import { Component, OnInit, AfterContentChecked } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavigationService } from './services/navigation/navigation.service';
import { UserService } from './services/management/user/user.service';
import { LoadingService } from './services/loading/loading.service';
declare var $;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentChecked {
  title = 'fspersonnel';
  private scrollTimer = null;
  constructor(private router: Router, private navigation: NavigationService, public userService: UserService, public ls: LoadingService) {
  }
  ngOnInit(): void {
    this.router.events.subscribe((event: NavigationEnd) => {
      $('body').scroll();
      this.scrollTimer = setTimeout(() => {
        this.navigation.scrollToElement();
        this.scrollTimer = null;
      }, 10);
    });
  }
  saveScrollId(elementId: string) {
    $('.navbar-collapse').collapse('hide');
    this.navigation.elementId = elementId;
    this.navigation.scrollToElement();
  }

  ngAfterContentChecked(){
    if (this.scrollTimer != null){
      clearInterval(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.navigation.scrollToElement();
        this.scrollTimer = null;
      }, 10);
    }
  }
}
